// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2aztb","footer":"ReportModalFilter_footer__3HdPM"};